import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import * as common from './translations';

i18n.use(initReactI18next).init({
  lng: 'en',
  defaultNS: 'common',
  fallbackLng: 'en',
  ns: ['common'],
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: common.en,
  },
});

export default i18n;
